// 动态处理el表格表头高度不正确的问题
let thHeightData = 0
export function dynamicHeight(){
  let thHeight = document.querySelectorAll(".has-gutter, th");
  const heightArr = []
  for (let i = 0; i < thHeight.length; i++) {
    heightArr.push(thHeight[i].offsetHeight)
  }
  if(heightArr && heightArr.length > 0){
    if(Math.max(...heightArr) !== thHeightData){
      for (let i = 0; i < thHeight.length; i++) {
        thHeight[i].style.height = Math.max(...heightArr) + 'px'
      }
      thHeightData = Math.max(...heightArr)
    }
  }
}
